import { SnackbarProvider } from "notistack"
import { Routes, Route, BrowserRouter } from "react-router-dom"

import Admin from "./components/Admin"
import LoginPage from "./components/Login"
import Commission from "./components/Commission"
import Billing from "./components/Billing/Billing"
import Deduplication from "./components/Deduplication"
import { RequireAuth } from "./components/RequireAuth"
import BillingSettings from "./components/Billing/BillingSettings"
import CommissionPayRoll from "./components/Commission/CommissionPayRoll"
import EditMaskStructure from "./components/Admin/pages/Mobile/EditMaskStructure"

function App() {
	return (
		<SnackbarProvider
			maxSnack={3}
			autoHideDuration={2500}
			preventDuplicate={true}>
			<BrowserRouter>
				<Routes>
					<Route path="/login" element={<LoginPage />} />

					<Route element={<RequireAuth />}>
						<Route path="/" element={<Admin />} />

						<Route path="/maskEdit">
							<Route path=":mask" element={<EditMaskStructure />} />
						</Route>

						<Route path="billing/*">
							<Route index element={<Billing />} />
							<Route path="settings" element={<BillingSettings />} />
						</Route>

						<Route path="commission/*" >
							<Route index element={<Commission />} />
							<Route path="payroll" element={<CommissionPayRoll />} />
						</Route>

						<Route path="/deduplication" element={<Deduplication />} />
					</Route>
				</Routes>
			</BrowserRouter>
		</SnackbarProvider>
	)
}

export default App